<template>
  <div class="flex items-center">
    <CopyHeadingLinkButton
      v-if="isHeading"
      :link-id="headingId"
      :absolute-position="false"
    />
    <DragHandle
      v-if="draggable"
      :element="element"
      :editor-id="editorId"
    />
  </div>
</template>

<script>
import DragHandle from './DragHandle';
import CopyHeadingLinkButton from './CopyHeadingLinkButton';

const headings = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

export default {
  name: 'BlockHoverMenu',

  components: {
    DragHandle,
    CopyHeadingLinkButton,
  },

  props: {
    element: {
      type: HTMLElement,
      required: true,
    },

    editorId: {
      type: String,
      required: true,
    },

    draggable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      isHeading: false,
      isDraggable: false,
      headingId: '',
      blockId: '',
    };
  },

  computed: {
    editor() {
      return this.$store.getters.editor(this.editorId);
    },
  },

  mounted() {
    this.checkElement();
  },

  methods: {
    checkElement() {
      const { nodeName } = this.element;

      if (headings.includes(nodeName)) {
        this.isHeading = true;
        this.headingId = this.element.getAttribute('id');
      }
    },
  },
};
</script>
